<template>
  <VueSlickCarousel
    ref="slick"
    v-bind="slickOptions"
    class="product-slick"
    v-if="products.product && products.product.length"
  >
    <div
      class="slick-item"
      v-for="(product, index) in products.product"
      :key="index"
      :product_id="product.id"
    >
      <div class="row product-row mx-5">
        <div class="col-xxl-5 col-md-6 col-12 p-0">
          <div
            class="product-img pointer"
            :style="{
              background:
                'url(' + (product.images.length ? product.images[0] : '') + ')',
            }"
            data-bs-toggle="modal"
            data-bs-target="#productModal"
            @click="showProductModal(product)"
          ></div>
        </div>
        <div class="col-xxl-7 col-md-6 col-12 p-0">
          <div class="product-content my-5 mx-5">
            <!-- <div>
              <span class="font-16 text-theme-2"
                >{{ product.title }}</span
              >
            </div> -->
            <div>
              <span class="font-24 fw-bold">{{ product.name }}</span>
            </div>
            <div class="py-2">
              <span class="font-24 fw-bold text-theme-3"
                >{{ products.currency_symbol
                }}{{ Number(product.price) | currencyFormat }}</span
              >
            </div>
            <div class="product-slick-product-details d-none d-lg-block">
              <!-- <ul class="truncate-6">
                <li>1 x Fruits Yogurt Cubes 80g</li>
                <li>
                  2 x Premium Freeze Dried Fruits (Mango 40g / Dragon Fruit 45g)
                </li>
                <li>
                  2 x Premium Freeze Dried Fruits (Mango 40g / Dragon Fruit 45g)
                </li>
                <li>
                  2 x Premium Freeze Dried Fruits (Mango 40g / Dragon Fruit 45g)
                </li>
                <li>
                  2 x Premium Freeze Dried Fruits (Mango 40g / Dragon Fruit 45g)
                </li>
                <li>
                  2 x Premium Freeze Dried Fruits (Mango 40g / Dragon Fruit 45g)
                </li>
                <li>
                  2 x Premium Freeze Dried Fruits (Mango 40g / Dragon Fruit 45g)
                </li>
              </ul> -->
              <p class="font-16 truncate-6" v-html="product.description"></p>
            </div>
            <div class="pb-4">
              <span
                class="font-14 fw-bold text-theme-1 pointer"
                data-bs-toggle="modal"
                data-bs-target="#productModal"
                @click="showProductModal(product)"
                >read more</span
              >
            </div>

            <!--With Variation-->
            <div id="withvariations" v-if="product.selections.length > 0">
              <button
                class="btn bg-theme-1 py-3 px-5"
                data-bs-toggle="modal"
                data-bs-target="#productModal"
                @click="showProductModal(product)"
                v-if="product.stock_status == 'instock'"
              >
                <span class="font-16 fw-bold text-white">Select Options</span>
              </button>
              <button
                class="btn bg-theme-5 py-3 px-5"                
                disabled
                v-else
              >
                <span class="font-16 fw-bold text-white">Out of stock</span>
              </button>  
            </div>
            <!--End of With Variation-->

            <!--Without Variation -->
            <div
              class="
                d-flex
                align-items-lg-center align-items-start
                flex-lg-row flex-column
              "
              id="withoutvariations"
              v-else
            >
              <div
                class="
                  add-remove-option
                  bg-white
                  d-flex
                  align-items-center
                  me-md-4
                  mb-md-0 mb-4
                "
                v-if="product.stock_status == 'instock'"
              >
                <div class="py-3 px-4 pointer" @click="reduceQuantity(product)">
                  <img src="@/img/product/minus.png" width="11px;" />
                </div>
                <div class="no-item-added py-3 px-4 pointer">
                  <span class="font-16 fw-bold">{{ product.quantity }}</span>
                </div>
                <div
                  class="py-3 px-4 pointer"
                  @click="increaseQuantity(product)"
                >
                  <img src="@/img/product/plus.png" width="11px;" />
                </div>
              </div>
              <button
                class="btn bg-theme-1 py-3 px-5 mt-lg-0 mt-4 add_to_cart_slick_btn"
                :id="'product-' + product.sku"
                @click="addToCart(product)"
                v-if="product.stock_status == 'instock'"
              >
                <span class="font-16 fw-bold text-white add_to_cart_slick_btn"
                :id="'product-' + product.sku + '-text'"
                >Add to cart</span>
              </button>
              <button
                class="btn bg-theme-5 py-3 px-5"                
                disabled
                v-else
              >
                <span class="font-16 fw-bold text-white">Out of stock</span>
              </button> 
            </div>
            <!--End of Without Variation-->
          </div>
        </div>
      </div>
    </div>
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";

export default {
  name: "ProductSlick",
  components: {
    VueSlickCarousel,
  },
  props: ["products", "cart"],
  data() {
    return {
      slickOptions: {
        arrows: true,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },
  filters: {
    currencyFormat: function (value) {
      let val = value.toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    increaseQuantity: function (itemToIncrease) {
      this.$parent.$parent.increaseQuantity(itemToIncrease);
    },
    reduceQuantity: function (itemToReduce) {
      this.$parent.$parent.reduceQuantity(itemToReduce);
    },
    showProductModal: function (product) {
      this.$parent.$parent.showProductModal(product);
    },
    addToCart: function (itemToAdd) {
      this.$parent.$parent.addToCart(itemToAdd);
    },
  },
};
</script>
